import feedingListPage from './pages/list/index.vue'
import feedingFormNewPage from './pages/form/index.vue'
import feedingFormEditPage from './pages/form/index.vue'

export default [
	{
		path: '/feeding',
		name: 'feedingList',
		component: feedingListPage
	},
	{
		path: '/feeding/new',
		name: 'feedingFormNew',
		component: feedingFormNewPage
	},
	{
		path: '/feeding/:id?',
		name: 'feedingFormEdit',
		component: feedingFormEditPage
	}
];